import { showDeleteConfirm } from "components/base/delete"
import { notifications } from "notifications"

export const defaultFilterOption = (input: string, option: any) => String(option?.children ?? option?.label ?? "")
  .toLowerCase().includes(input.toLowerCase())

export const handleDeleteWithConfirm = async(
  name: string,
  deleteFn: () => Promise<void>,
  successMessage: string,
  errorMessage: string,
) => {
  showDeleteConfirm(
    name,
    undefined,
    async() => {
      try {
        await deleteFn()
        notifications.success(successMessage)
      } catch (error: any) {
        notifications.error(error?.cause?.message || error?.message || errorMessage)
      }
    },
  )
}
